import { $black } from './commonColors';

const primaryMain = '#F04E29';
const primaryMainOpacity = 'rgba(240, 78, 41, 0.9)';
const secondaryMain = $black;
const secondaryMainOpacity = 'rgba(0, 0, 0, 0.5)';
const secondaryLight = '#FFCE00';
const tertiaryMain = '#471105';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  logoContainerMobile: {
    height: 30,
    marginBottom: 20
  },
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
